var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortAscending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8332 14.1667H18.3332L14.9998 17.5L11.6665 14.1667H14.1665V2.5H15.8332V14.1667ZM1.6665 14.1667H9.99984V15.8333H1.6665V14.1667ZM4.99984 4.16667V5.83333H1.6665V4.16667H4.99984ZM1.6665 9.16667H7.49984V10.8333H1.6665V9.16667Z",
    fill: "#2D5B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortAscending);
export default __webpack_public_path__ + "static/media/sort-ascending.e8e0c112b4d393efdfc5e625bed59788.svg";
export { ForwardRef as ReactComponent };